import { useRef, useState } from 'react'
import type ReactECharts from 'echarts-for-react'
import { useEconomicAreaData } from '../../../hooks/useEconomicAreaData'
import EconomicAreaScatterChart from '../../../chart/EconomicAreaScatterChart'
import { RiskProfileCard } from '../../RiskProfileCard'
import { ChartQueryState } from '../../ChartQueryState'
import { ChartExportActions } from '../../../chart/ChartExportActions'
import { useExportXlsx } from '../../../hooks/useExportXlsx'
import { useExportChartImage } from '../../../hooks/useExportChartImage'
import { InterpretToggle, InterpretPanel } from '../../InterpretToggle'
import type {
  PropertiesQueryParams,
  PropertiesMetricOption,
} from '../../../types/riskProfileProperties.types'

export interface EconomicAreaScatterWidgetProps {
  queryParams: PropertiesQueryParams | null
  metricOption: PropertiesMetricOption
  entityNoun: string
}

export function EconomicAreaScatterWidget({
  queryParams,
  metricOption,
  entityNoun,
}: EconomicAreaScatterWidgetProps) {
  const [showInterpret, setShowInterpret] = useState(false)
  const { request, query } = useEconomicAreaData(queryParams)
  const { exportXlsx, isExporting } = useExportXlsx(request, '/report/risk-profile/properties/xlsx')
  const chartRef = useRef<ReactECharts>(null)
  const handleExportImage = useExportChartImage(chartRef, `${entityNoun}-disrupted-by-area-scatter`)

  return (
    <RiskProfileCard
      title={`Number and share of ${entityNoun} disrupted`}
      description={`Number and share of ${entityNoun} disrupted, by area.`}
      onExport={
        <div className="flex items-center gap-2">
          {/* TODO: add interpret toggle when Matt and Emma sort out the content */}
          {/* <InterpretToggle active={showInterpret} onClick={() => setShowInterpret((v) => !v)} /> */}
          <ChartExportActions
            onExportXlsx={exportXlsx}
            onExportImage={handleExportImage}
            isExportingXlsx={isExporting}
            xlsxDisabled={!request}
          />
        </div>
      }
      className="min-h-96"
    >
      {showInterpret && (
        <InterpretPanel>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          <p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
          <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>
        </InterpretPanel>
      )}
      <ChartQueryState query={query}>
        {(data) => (
          <EconomicAreaScatterChart
            ref={chartRef}
            data={data}
            metricOption={metricOption}
            entityNoun={entityNoun}
          />
        )}
      </ChartQueryState>
    </RiskProfileCard>
  )
}
